import moment from 'moment'
import { useQuery } from 'react-query'
import hooks from '../../../hooks'

const useUserReflection = ({
    userId,
    promptId,
}) => {

    const cacheKeys = hooks.useCacheKeys()
    const { api, endpoints, url, time } = hooks.useApi()
    const { id: currentUserId } = hooks.useCurrentUser()

    const { data, isLoading } = useQuery(
        [cacheKeys.USER_REFLECTIONS, userId, promptId],
        () => api.get(url(endpoints.userReflection, {userId, promptId })),
        {
            staleTime: time.HOUR,
            enabled: Boolean(userId) && Boolean(promptId)
        }
    )
    const userReflection = data || {}
    const { startDate, endDate } = userReflection
    const isEditable = Boolean(userReflection) &&
        moment(startDate).startOf('day').isSameOrBefore(moment()) &&
        moment(endDate).endOf('day').isSameOrAfter(moment()) &&
        currentUserId === userId


    return {
        userReflection,
        isLoadingUserReflection: isLoading,
        isEditable
    }
}

export default useUserReflection
